const UI_TYPES = {
  GENERATION_GENIUS: "GENERATION_GENIUS",
  LITE: "LITE",
  PREMIUM: "PREMIUM",
  LITE_USER_PREMIUM_CONTENT: "LITE_USER_PREMIUM_CONTENT",
  PREMIUM_USER_LITE_CONTENT: "PREMIUM_USER_LITE_CONTENT",
  UNAUTHENTICATED_USER: "UNAUTHENTICATED_USER",
};

export default UI_TYPES;
